export default __webpack_public_path__ + "static/media/office1-before1-1440w.6ce502fd.webp";